import { observer } from "mobx-react";
import React, { } from 'react';
import styles from "./index.module.scss";
import { useStores } from "../../stores/RootStore";
import { ethers } from "ethers";
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';

const RangeSlider = observer(() => {
    const { t } = useTranslation();
    const { etherStore } = useStores();
    const { sliderValue, setSliderValue, currentPrice } = etherStore;
    const price = ethers.utils.formatEther(currentPrice);

    const handleChange = (event) => {
        setSliderValue(event.target.value);
    }

    return (
        <div className={styles["slider-wrapper"]}>
            <div className={styles["slidecontainer"]}>
                <div className={styles["slider-title"]}>
                    {t("range_slider.title")} : {sliderValue}
                </div>
                <div className={styles["slider-explain"]}>
                    {'(Move slider to increase)'}
                </div>
                <input type="range" min={1} max={5} value={sliderValue} onChange={handleChange}
                    className={styles["slider"]} id="myRange" />
            </div>
            <div className={styles["slider-title"]}>
                {t("range_slider.total_cost")}<NumberFormat
                    value={(price * sliderValue).toFixed(0)}
                    displayType={'text'}
                    thousandSeparator={true} />
                <div className={styles["currency"]}>{' þ'}</div>
            </div>
        </div>
    )
});

export default RangeSlider;
